import { Box, Checkbox } from '@aicon-dev/caas-ui';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Divider } from '~/components/ui/Divider';
import { Form } from '~/components/ui/Form';
import { useModals } from '~/router';

import { policyList, policyListAnchor } from '../libs/styles.css';
import { UserFormValues } from '../libs/types';

export const UserFormPolicy = () => {
  const { t } = useTranslation('user_info');
  const { control } = useFormContext<UserFormValues>();
  const modals = useModals();

  return (
    <>
      <Box px="16" py="24">
        <Form.ItemControlled
          control={control}
          name="marketingAgree"
          style={{ marginBottom: 16 }}
          render={({ field: { value, onChange } }) => {
            return (
              <Checkbox checked={value} onChange={onChange}>
                {t('user_info:agreement_marketing_policy')}({t('user_info:agreement_optional')})
              </Checkbox>
            );
          }}
        />

        <Divider />

        <ul className={policyList}>
          <li>
            <a
              className={policyListAnchor}
              onClick={() => modals.open('/terms-of-service', { preventScrollReset: false })}
            >
              {t('user_info:m_terms_of_use_see')}
            </a>
          </li>
          <li>
            <a
              className={policyListAnchor}
              onClick={() => modals.open('/privacy', { preventScrollReset: false })}
            >
              {t('user_info:m_privacy_policy_see')}
            </a>
          </li>
        </ul>
      </Box>

      <Divider size="large" />
    </>
  );
};
